import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.5" y="0.5" width="6.71642" height="6.71642" rx="2.25" fill={color}/>
        <rect x="0.5" y="8.78357" width="6.71642" height="6.71642" rx="2.25" fill={color}/>
        <rect x="8.7836" y="8.78357" width="6.71642" height="6.71642" rx="2.25" fill={color}/>
        <path d="M14.3918 3.85828L9.89185 3.85828" stroke={color} strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M12.1418 6.10828L12.1418 1.60828" stroke={color} strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)

export default class IconAddBlock extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
